import { render, staticRenderFns } from "./DictItemModal.vue?vue&type=template&id=c54dea54&"
import script from "./DictItemModal.vue?vue&type=script&lang=js&"
export * from "./DictItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c54dea54')) {
      api.createRecord('c54dea54', component.options)
    } else {
      api.reload('c54dea54', component.options)
    }
    module.hot.accept("./DictItemModal.vue?vue&type=template&id=c54dea54&", function () {
      api.rerender('c54dea54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DictItemModal.vue"
export default component.exports